<template>
  <v-container
    class="align-center px-md-16"
    style="height: 80vh; display: grid"
  >
    <v-card class="bg-card rounded-xl py-5 mt-5">
      <h4 class="text-center text-h4 mb-5">Lista de reproducción</h4>

      <v-form ref="form" v-model="valid" lazy-validation>
        <div class="mx-5 mx-md-8 px-md-8">
          <v-checkbox
            label="Repoducir videos"
            v-model="updatedData.playVideo"
          ></v-checkbox>

          <label for="interval" class="ml-4 black--text font-weight-medium"
            >Reproducir videos cada X Minutos</label
          >
          <v-text-field
            id="interval"
            placeholder="Número"
            color="primary"
            rounded
            required
            outlined
            type="number"
            class="mt-2"
            :rules="[rules.required, rules.number]"
            v-model="updatedData.playVideoEveryMinutes"
          ></v-text-field>

          <label for="interval" class="ml-4 black--text font-weight-medium"
            >Lista de reproducción para música de fondo</label
          >
          <v-text-field
            id="interval"
            placeholder="https://youtube.com/playlist?list=XXXXX"
            color="primary"
            rounded
            required
            outlined
            class="mt-2"
            v-model="updatedData.playlistBackground"
          ></v-text-field>

          <v-row class="mb-3 align-center">
            <p for="interval" class="black--text font-weight-medium mb-0">
              Videos
            </p>
            <v-btn icon @click="addVideo">
              <v-icon small color="green">fa-plus</v-icon>
            </v-btn>
          </v-row>
          <div v-for="(video, index) in updatedData.playlist" :key="index">
            <v-row>
              <v-text-field
                v-model="updatedData.playlist[index]"
                placeholder="https://www.youtube.com/watch?v=XXXXXX"
                outlined
                required
                color="primary"
                rounded
                dense
              ></v-text-field>
              <v-btn icon @click="deleteVideo(index)">
                <v-icon small color="red">fa-trash</v-icon>
              </v-btn>
            </v-row>
          </div>
        </div>
      </v-form>

      <div
        class="d-flex flex-column flex-md-row align-center justify-center"
        v-if="disabled"
      >
        <v-btn
          color="primary"
          class="rounded-lg my-2 my-md-0 px-5 elevation-0"
          @click="updated"
        >
          <v-icon>fa-pen</v-icon>
          <span class="text-capitalize ml-2 font-weight-bold">Actualizar</span>
        </v-btn>
      </div>

      <div
        class="d-flex flex-column flex-md-row align-center justify-center mx-md-16"
        v-else
      >
        <v-btn
          color="secondary"
          outlined
          class="rounded-lg mr-md-16 my-2 my-md-0"
          @click="updated"
        >
          <v-icon>fa-times</v-icon>
          <span class="text-capitalize ml-2 font-weight-bold">Cancelar</span>
        </v-btn>

        <v-btn
          color="primary"
          class="rounded-lg ml-md-16 my-2 my-md-0 elevation-0"
          @click="submit"
          :loading="loading"
        >
          <v-icon>fa-check</v-icon>
          <span class="text-capitalize ml-2 font-weight-bold">Aceptar</span>
        </v-btn>
      </div>
    </v-card>

    <alerts-cli />
  </v-container>
</template>

<script>
import Swal from 'sweetalert2'
import AlertsCli from '@/components/Alerts.vue'
import Repository from '@/repositories/RepositoryFactory'

const MonitorConfigRepository = Repository.get('monitorConfig')

export default {
  name: 'MonitorConfig',
  components: {
    AlertsCli,
  },
  data: () => ({
    rules: {
      required: (value) => !!value || 'Campo requerido.',
      number: (value) => {
        const pattern = /[^0-9]/
        return !pattern.test(value) || 'Campo inválido.'
      },
    },
    currentData: {
      id: 1,
      playVideo: false,
      playVideoEveryMinutes: 0,
      playlist: [],
      playlistBackground: '',
    },
    updatedData: {
      id: 1,
      playVideo: false,
      playVideoEveryMinutes: 0,
      playlist: [],
      playlistBackground: '',
    },
    show: false,
    valid: false,
    disabled: true,
    loading: false,
  }),
  computed: {
    roleUser: function () {
      return this.$store.state.auth.user?.roleId || ''
    },
  },
  mounted: async function () {
    await this.loadData()
  },
  methods: {
    addVideo: function () {
      this.updatedData.playlist.push('')
    },
    deleteVideo: function (index) {
      this.updatedData.playlist.splice(index, 1)
    },
    loadData: async function () {
      this.$eventBus.emit('loading-page')
      try {
        const res = await MonitorConfigRepository.get()
        const _data = res.data.data
        this.currentData = {
          id: _data.id,
          playVideo: _data.playVideo,
          playVideoEveryMinutes: _data.playVideoEveryMinutes,
          playlist: _data.playlist,
          playlistBackground: _data.playlistBackground,
        }

        this.updatedData = Object.assign(
          {},
          {
            id: _data.id,
            playVideo: _data.playVideo,
            playVideoEveryMinutes: _data.playVideoEveryMinutes,
            playlist: _data.playlist,
            playlistBackground: _data.playlistBackground,
          }
        )
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('user')
          location.reload()
        }

        const response = error.response ? error.response.data.message : error

        console.log(response)
      }
    },
    updated: function () {
      this.disabled = !this.disabled
      // this.updatedData = Object.assign({}, this.currentData)
    },

    submit: async function () {
      this.$refs.form.validate()

      setTimeout(async () => {
        if (this.valid) {
          await this.update()
        }
      }, 500)
    },

    update: async function () {
      this.loading = true
      try {
        const res = await MonitorConfigRepository.update(
          {
            ...this.updatedData,
            playlist: this.updatedData.playlist.filter((p) => p !== ''),
          },
          this.updatedData.id
        )

        const data = {
          type: 'success',
          title: 'Petición exitosa',
          text: res.data.message,
        }

        this.$store.dispatch('alerts/activeAlerts', data)
        this.disabled = true
        this.show = false
      } catch (error) {
        const response = error.response
          ? error.response.data.message ||
            error.response.data.errors?.reduce((acc, cur) => ({
              msg: acc.msg + ', ' + cur.msg,
            })).msg
          : error

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response,
        })
      }
      this.loading = false
    },
  },
}
</script>
